@if (!!coverageChangeQuoteForm) {
  <div class="replace-vehicle main">
    <div class="row">
      <div class="column twelve lg-push-two lg-eight">
        @if (!!(quoteRequestError$ | async)) {
          <div class="row lg-flex pad-bottom-20">
            <div class="column ten flex-min-0">
              <ds-error-message [errorList]="policyErrorList"></ds-error-message>
            </div>
          </div>
        }
        <div class="row">
          <div class="column twelve pad-bottom-20">
            <h4 class="heading-sub-section">
              Edit your comprehensive and collision coverage deductibles
            </h4>
          </div>
          <div class="column ten md-six">
            <form [formGroup]="coverageChangeQuoteForm" data-cy="coverageChangeQuoteForm">
              <div class="flex items-center pad-bottom-20">
                <ds-form-control-container
                  labelText="Comprehensive Coverage Deductible"
                  labelClass="no-float"
                  [control]="coverageChangeQuoteForm.controls['comprehensiveCoverageInput']"
                >
                  <select
                    id="comprehensiveCoverage"
                    class="icon fill"
                    formControlName="comprehensiveCoverageInput"
                    (change)="onCoverageChange($event.target)"
                    data-cy="coverageChangeQuoteFormComprehensiveCoverageSelect"
                  >
                    @for (
                      comprehensiveCoverage of comprehensiveCoverageInputValues$ | async;
                      track comprehensiveCoverage
                    ) {
                      <option [value]="comprehensiveCoverage">${{ comprehensiveCoverage }}</option>
                    }
                  </select>
                  <span class="icon-chevron-down"></span>
                </ds-form-control-container>
                <ds-clicktip-icon
                  ariaDescribedBy="showComprehensiveInfo"
                  [clicktipRef]="comprehensiveClicktip"
                ></ds-clicktip-icon>
              </div>
              <div class="row">
                <div class="column twelve">
                  <ds-clicktip
                    #comprehensiveClicktip
                    label="showComprehensiveInfo"
                    title="What is comprehensive insurance?"
                    text="Comprehensive car insurance covers damage caused by accidents that don't involve colliding with another vehicle or object.
                That means this type of smart coverage, minus the cost of your comprehensive deductible, pays for damage caused by things like
                theft, collisions with animals, vandalism, fire, hail, floods, and some falling objects."
                  ></ds-clicktip>
                </div>
              </div>
              <div class="flex items-center pad-bottom-20">
                <ds-form-control-container
                  labelText="Collision Coverage Deductible"
                  labelClass="no-float"
                  [control]="coverageChangeQuoteForm.controls['collisionCoverageInput']"
                >
                  <select
                    id="collisionCoverage"
                    class="icon fill"
                    formControlName="collisionCoverageInput"
                    (change)="onCoverageChange($event.target)"
                    data-cy="coverageChangeQuoteFormCollisionCoverageSelect"
                  >
                    @for (
                      collisionCoverage of collisionCoverageInputValues$ | async;
                      track collisionCoverage
                    ) {
                      <option [value]="collisionCoverage">${{ collisionCoverage }}</option>
                    }
                  </select>
                  <span class="icon-chevron-down"></span>
                </ds-form-control-container>
                <ds-clicktip-icon
                  ariaDescribedBy="showCollisonInfo"
                  [clicktipRef]="collisionClicktip"
                ></ds-clicktip-icon>
              </div>
              <div class="row">
                <div class="column twelve">
                  <ds-clicktip
                    #collisionClicktip
                    label="showCollisonInfo"
                    title="What is collision insurance?"
                    text="Collision insurance is an optional coverage that helps pay the cost of repairing or
                replacing your car after being damaged in an accident, whether it's your fault or
                not. Usually, when you are involved in a covered accident, you'll pay a collision
                insurance deductible, which is a set amount of money you will pay out-of-pocket
                prior to your insurance payment."
                  ></ds-clicktip>
                </div>
              </div>
              <!-- TODO: Add condition to only show this if the customer does not already have ERA -->
              <div class="row pad-top-10">
                @if (!eraExisting) {
                  <div class="column twelve pad-top-20 pad-bottom-20">
                    <input
                      type="checkbox"
                      class="checkbox"
                      id="eraInput"
                      formControlName="eraInput"
                      data-cy="coverageChangeQuoteFormEraInput"
                    />
                    <label for="eraInput" class="checkbox-label">
                      Add Emergency Roadside Assistance
                    </label>
                  </div>
                }
                <!-- TODO: Add condition to only show this if the customer does not already have Rental -->
                @if (!rentalExisting) {
                  <div class="column twelve pad-bottom-20">
                    <input
                      type="checkbox"
                      class="checkbox"
                      id="rentalInput"
                      formControlName="rentalInput"
                      (change)="rentalToggle($event.target.checked)"
                      data-cy="coverageChangeQuoteFormAddRentalCheckbox"
                    />
                    <label for="rentalInput" class="checkbox-label">
                      Add Rental Reimbursement
                    </label>
                  </div>
                }
                @if (showRentalValues || !!rentalExisting) {
                  <div class="column twelve">
                    <ds-form-control-container
                      labelText="Rental Reimbursement Amount"
                      labelClass="no-float"
                      [control]="coverageChangeQuoteForm.controls['rentalReimbursementsInput']"
                    >
                      <select
                        id="rentalReimbursement"
                        class="icon fill"
                        formControlName="rentalReimbursementsInput"
                        (change)="onCoverageChange($event.target)"
                        data-cy="coverageChangeQuoteFormAddRentalAmountSelect"
                      >
                        <option value=""></option>
                        @for (
                          rentalReimbursement of rentalReimbursementsInputValues$ | async;
                          track rentalReimbursement
                        ) {
                          <option [value]="rentalReimbursement">
                            {{ rentalReimbursement | formatRentalDeductibles }}
                          </option>
                        }
                      </select>
                      <span class="icon-chevron-down"></span>
                    </ds-form-control-container>
                  </div>
                }
              </div>
              <div class="row pad-top-40" id="missingCoverageInfo" data-cy="missingCoverageInfo">
                <p>
                  If you don't see the type of coverage you'd like to change, please contact your
                  agent:
                  {{ agentPhoneNumber$ | async }}
                </p>
              </div>
            </form>
          </div>
          <div class="column twelve md-pad-left-40 md-six">
            <div class="row">
              <div class="column twelve md-six">
                <ds-premium-detail [quote]="currentQuote$ | async"></ds-premium-detail>
              </div>
            </div>
          </div>
          <div class="column twelve pad-top-20">
            <button
              ds-button
              class="btn md-float-right md-margin-right-40"
              (click)="getQuote(currentVehicle)"
              [disabled]="buttonDisabled || !coverageChangeQuoteForm.valid"
              data-cy="coverageChangeQuoteButton"
            >
              Get a Quote
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
